var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-row', {
    staticClass: "theme-chip align-center px-2 pt-2 no-gutters",
    class: {
      'theme-selected': _vm.isSelected || _vm.forceSelection
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.toggleSpecialty.apply(null, arguments);
      }
    }
  }, [_c('v-col', {
    staticClass: "d-flex",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', [_c('ph-check-square', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isSelected,
      expression: "isSelected"
    }],
    staticClass: "clickable mr-3 secondary--text",
    attrs: {
      "weight": "fill",
      "size": "24"
    }
  }), _c('ph-square', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isSelected,
      expression: "!isSelected"
    }],
    staticClass: "clickable mr-3 grey--text text--lighten-6",
    attrs: {
      "weight": "thin",
      "size": "24"
    }
  })], 1), _c('div', {
    staticClass: "heading text-l-large-semibold grey--text text--darken-4 text-truncate"
  }, [_vm.$breakpoint.tabletAndDown ? _c('span', [_vm._v(" " + _vm._s(_vm.primaryTitle) + " ")]) : _vm._e(), _vm.$breakpoint.smallDesktopAndUp ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('span', _vm._g(_vm._b({
          staticClass: "text-truncate"
        }, 'span', attrs, false), on), [_vm._v(_vm._s(_vm.primaryTitle))])];
      }
    }], null, false, 1380619340)
  }, [_c('span', [_vm._v(_vm._s(_vm.primaryTitle))])]) : _vm._e(), _c('span', {
    staticClass: "clickable text rounded-lg text-capitalize theme-btn-text",
    class: _vm.handleForSubspecialtiesAccordionButton,
    attrs: {
      "disabled": _vm.subspecialties == undefined || _vm.subspecialties.length == 0
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.toggleOpenSubspecialties.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.subspecialtiesBtnText) + " ")])], 1)])], 1), _vm.showSubspecialties && _vm.subspecialties.length > 0 ? _c('v-row', {
    staticClass: "mt-0",
    attrs: {
      "justify": "end"
    }
  }, [_c('v-col', {
    staticClass: "pt-4",
    attrs: {
      "cols": "11"
    }
  }, _vm._l(_vm.subspecialties, function (subspec, index) {
    return _c('SubSpecialtyComponent', {
      key: subspec.id,
      class: {
        'mb-2': _vm.isNotLastSubspecialty(index)
      },
      attrs: {
        "id": subspec.id,
        "title": subspec.title,
        "force-selection": subspec.forceSelection
      },
      on: {
        "select-sub": function ($event) {
          return _vm.$emit('select-sub', _vm.primaryId, subspec.id);
        },
        "deselect-sub": function ($event) {
          return _vm.$emit('deselect-sub', _vm.primaryId, subspec.id);
        }
      }
    });
  }), 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }